import { BondsCall } from '../type';

export const transformCmtHist = (cmtHist: BondsCall['EVT_ENTRY_S.CMT_HIST'] | undefined) => {
  if (cmtHist == null) {
    return undefined;
  }
  return parseFloat(cmtHist);
};
